module.exports = __webpack_public_path__ + "static/img/help.a9d40578.png";